import { defineMessages } from "react-intl";

export const messages = defineMessages({
    bannerTitleWithName: {
        id: "fastshift.dashboard.welcome-banner.title-with-name",
        defaultMessage: "Hello, {name}!",
        description: "Greeting message for the welcome banner"
    },
    bannerTitleWithoutName: {
        id: "fastshift.dashboard.welcome-banner.title-without-name",
        defaultMessage: "Hello!",
        description:
            "Greeting message for the welcome banner when the user's name is not available"
    }
});
